import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import { PriceDropContext } from '@context/price-drop-context';
import 'swiper/css';
import { useContextSelector } from 'use-context-selector';
import ProductRecapC2C from '../product-recap/product-recap-c2c';
import { PriceDropForm } from './form/price-drop-form';
import { SoldProductsFrame } from './soldProduct/sold-products-frame/sold-products-frame';
import styles from './drop-price.module.scss';

export interface DropPriceComponentProps {
  productPath: string;
}

export const DropPrice = ({ productPath }) => {
  const { t } = useTranslation('price-drop');
  const selectedProductC2C = useContextSelector(PriceDropContext, (a) => a.selectedProductC2C);
  const isPriceRecommendationLoading = useContextSelector(PriceDropContext, (a) => a.isPriceRecommendationLoading);

  if (isPriceRecommendationLoading || !selectedProductC2C) {
    return;
  }

  return (
    <>
      <div className={clsx(styles.dropPrice__wrapper, 'innerContainer')}>
        <h2 className={styles.dropPrice__title}>{t('PRICE_DROP.TITLE.PRICE_DROP')}</h2>
        <div className={clsx(styles.dropPrice, 'vc-text-s')}>
          <div className={styles.dropPrice__productInfo}>
            <ProductRecapC2C
              selectedProduct={selectedProductC2C}
              productPath={productPath}
              dialogType={'drop-price'}
              overrideStyles={styles.dropPrice__productInfo__content}
            />
          </div>
          <PriceDropForm selectedProduct={selectedProductC2C} />
        </div>
      </div>
      <SoldProductsFrame className={styles.dropPrice__similarItems} />
    </>
  );
};
